<div
  *ngIf="!live"
  class="slot"
  [class.ellipsis]="ellipsis"
  [ngClass]="{ ellipsis: ellipsis, mini: mini, 'on-flexed': onFlexed }"
  [ngStyle]="getSlotStyle()"
>
  <mat-icon
    *ngIf="break"
    fontSet="fa"
    fontIcon="fa-flag"
    [style.color]="color"
  ></mat-icon>
  <span>{{ name }}</span>
</div>

<div *ngIf="live" class="live-slot ellipsis"><span class="dot">•</span> LIVE</div>
